var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTtdInfoCalenderIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.4082 5.09375V7.54375",
    stroke: "#4258BF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9414 5.09375V7.54375",
    stroke: "#4258BF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.825 13.2044V20.1461C20.825 22.5961 19.6 24.2294 16.7417 24.2294H10.2083C7.35 24.2294 6.125 22.5961 6.125 20.1461V13.2044C6.125 10.7544 7.35 9.12109 10.2083 9.12109H16.7417C19.6 9.12109 20.825 10.7544 20.825 13.2044Z",
    fill: "#D1D9FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0252 10.4036V17.3453C18.0252 19.7953 16.8002 21.4286 13.9419 21.4286H7.40853C4.5502 21.4286 3.3252 19.7953 3.3252 17.3453V10.4036C3.3252 7.95365 4.5502 6.32031 7.40853 6.32031H13.9419C16.8002 6.32031 18.0252 7.95365 18.0252 10.4036Z",
    fill: "white",
    stroke: "#4258BF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7334 10.8867H17.6167",
    stroke: "#4258BF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6714 14.6505H10.6788",
    stroke: "#4258BF",
    strokeWidth: 1.68,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.64896 14.6505H7.6563",
    stroke: "#4258BF",
    strokeWidth: 1.68,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.64896 17.0997H7.6563",
    stroke: "#4258BF",
    strokeWidth: 1.68,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7754 0.664062C20.2102 2.84744 21.0794 3.72502 23.2754 4.16406C21.0788 4.60311 20.2097 5.48068 19.7754 7.66406C19.3406 5.48068 18.4714 4.60259 16.2754 4.16406C18.4719 3.72502 19.3411 2.84744 19.7754 0.664062Z",
    fill: "#D1D9FF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5746 4.86328C22.8355 6.17331 23.357 6.69985 24.6746 6.96328C23.3567 7.22671 22.8352 7.75325 22.5746 9.06328C22.3137 7.75325 21.7922 7.2264 20.4746 6.96328C21.7925 6.69985 22.314 6.17331 22.5746 4.86328Z",
    fill: "#D1D9FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTtdInfoCalenderIcon);
export default __webpack_public_path__ + "static/media/ttd-info-calender-icon.6e68f84c7bb64b26898082d814fd8204.svg";
export { ForwardRef as ReactComponent };